import { render } from "./BlockDiscount.vue?vue&type=template&id=02008155"
import script from "./BlockDiscount.vue?vue&type=script&lang=js"
export * from "./BlockDiscount.vue?vue&type=script&lang=js"

import "./BlockDiscount.vue?vue&type=style&index=0&id=02008155&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__